import { render, staticRenderFns } from "./mo-textarea-wrapper.html?vue&type=template&id=68fbcc00&external"
import script from "./mo-textarea-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-textarea-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports